import { AppStepMapping } from 'App.interface';
import { JourneyData } from 'data';
import { NavigationPath } from 'interfaces';
import { Preset, PresetDefinition } from 'presets';
import { NEXT_STEP_MAPPING_PP, PREVIOUS_STEP_MAPPING_PP } from './routers/DevisPP.router';
import { NEXT_STEP_MAPPING_MRH, PREVIOUS_STEP_MAPPING_MRH } from './routers/DevisMRH.router';

const nextStepMapping = (preset: Preset| undefined): AppStepMapping => {
    if (preset === 'DevisMRH') {
        return NEXT_STEP_MAPPING_MRH;
    }

    if (preset === 'DevisPP') {
        return NEXT_STEP_MAPPING_PP;
    }

    return NEXT_STEP_MAPPING_MRH;
};
const previousStepMappings = (preset: Preset| undefined): AppStepMapping => {
    if (preset === 'DevisMRH') {
        return PREVIOUS_STEP_MAPPING_MRH;
    }

    if (preset === 'DevisPP') {
        return PREVIOUS_STEP_MAPPING_PP;
    }

    return PREVIOUS_STEP_MAPPING_MRH;
};
export function getNextStepFrom(
    currentStep: NavigationPath,
    preset: PresetDefinition,
    journeyData: JourneyData,
): NavigationPath | undefined {
    const getNextStep = nextStepMapping(preset.type)[ currentStep ];
    return getNextStep ? getNextStep(preset, journeyData) : undefined;
}

export function getPreviousStepFrom(
    currentStep: NavigationPath,
    preset: PresetDefinition,
    journeyData: JourneyData,
): NavigationPath | undefined {
    const getPreviousStep = previousStepMappings(preset.type)[ currentStep ];
    return getPreviousStep ? getPreviousStep(preset, journeyData) : undefined;
}
